export default __webpack_public_path__ + "static/media/rightArrow.7ad4d828.svg";